import { render, staticRenderFns } from "./PublisherCertificate.vue?vue&type=template&id=3170e2bc"
import script from "./PublisherCertificate.vue?vue&type=script&lang=js"
export * from "./PublisherCertificate.vue?vue&type=script&lang=js"
import style0 from "./PublisherCertificate.vue?vue&type=style&index=0&id=3170e2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports